import {
  homepageImageCreateApi,
  homepageImageListApi,
} from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { homepageImageActions } from "./actions";

export function* homepageImageSaga() {
  yield takeEveryFsa(
    homepageImageActions.fetchHomepageImage.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        homepageImageActions.fetchHomepageImage,
        homepageImageListApi
      );
    }
  );

  yield takeEveryFsa(
    homepageImageActions.createNewHomepageImage.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        homepageImageActions.createNewHomepageImage,
        homepageImageCreateApi
      );
    }
  );
}
